import { gql } from "@apollo/client";

const DELETE_IIA = gql`
  mutation deleteIIA($id: String!) {
    deleteIIA(id: $id)
  }
`;

export default DELETE_IIA;
